import ErrorPage from './default';
import { ALREADY_PURCHASE_TV as TEXTS } from './constants';

function AlreadyPurchaseTv(props) {
  return (
    <ErrorPage
      {...props}
      title={TEXTS.TITLE}
      iconColor="BLUE"
      iconId="informacion"
      buttonText={TEXTS.BUTTON_TEXT}
      buttonHref={TEXTS.BUTTON_HREF}
      description=""
      showLink={false}
      componentContent="already-purchase-tv"
      columnForm
    />
  );
}
export default AlreadyPurchaseTv;
